import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Check } from 'lucide-react';

// Mixins / Modules
import Window from '../../../../../../modules/window';

// Models
import User from '../../../../../../models/v2/user';

// Base
import Button from '../../../../base/button';
import Card from '../../../../base/card';

// Related Components
import Popup from './promo/popup';

export default class Promo extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    plan: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onSubscribe: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      sending: false,
      plan: props.plan, // Popup allows plan selection, use state to store that, but props to store promo
    };
  }

  get isSelected() {
    const { plan } = this.props;
    return plan === 'promo';
  }

  handleSelect = (plan) => {
    this.setState({ plan });
  }

  handleSetMessage = (message) => {
    this.setState({ message });
  }

  handleConfirm = () => {
    const { user, duration, onSubscribe } = this.props;
    const { plan, message, sending } = this.state;

    if (sending) return;

    this.setState({
      sending: true,
      isOpen: false,
    }, () => {
      const data = {
        id: user.id,
        plan_name: plan,
        plan_promo: 'spring',
        plan_duration: duration,
        plan_message: plan === 'enterprise' ? message : '',
        send_plan_notification: true,
      };
      (new User(data))
        .save()
        .then((user) => {
          const view = user.plan_name === 'enterprise' ? 'confirm_call' : 'congratulations';
          onSubscribe(user, view);
        })
        .catch((error) => {
          Window.flash.error(error);
          this.setState({ sending: false });
        })
    })
  }

  handleOpen = () => {
    const { onSelect } = this.props;
    this.setState({
      isOpen: true
    }, () => onSelect('promo'));
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  }

  render() {
    const { onSelect } = this.props;
    const { isOpen, sending } = this.state;

    return (
      <Card {...{
        className: classNames('promo width-380 height-625 relative padding-left-31', {
          selected: this.isSelected,
          hoverable: !this.isSelected,
        }),
        onClick: () => onSelect('promo'),
      }}>
        <div className='card-badge absolute top-0 right-0'>Special Offer</div>
        <div className='pricing-card-list margin-top-40'>
          <div className='xlg-font semi-bold height-38'>
            🌷 March Into Spring 🌷
          </div>
          <div className='font-size-36 height-52 margin-bottom-15'>
            Spring Promo
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Free Access for 4-Weeks
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              25% Off Listed Price
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              No Commitment Time
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              No Cancellation Fees
            </div>
          </div>
          <div className='height-52 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Offer Valid until March, 31st<br />
              2025
            </div>
          </div>
          <div className='absolute bottom-40 left-31 width-290'>
            <Button {...{
              text: 'ACCESS FREE TRIAL',
              block: true,
              className: 'border-radius-4 width-290',
              size: 'xlg',
              onClick: () => this.handleOpen(),
              disabled: sending,
            }} />
          </div>
          <Popup {...{
            isOpen,
            onSelect: this.handleSelect,
            onSetMessage: this.handleSetMessage,
            onConfirm: this.handleConfirm,
            onCancel: this.handleClose,
          }} />
        </div>
      </Card>
    )
  }
}